import requester from '@/lib/axios';
import { BlockCodeActivityProgress } from '@/models/ActivityProgress';

export type BlockActivityProgressParam = {
  progressId: number;
  activityId: number;
};

export type UpdateBlockActivityProgressParams = {
  answer?: object;
  answerWorkspace?: object;
  isDone?: boolean;
};

export const getBlockActivityProgress = async ({
  progressId,
  activityId,
}: BlockActivityProgressParam): Promise<BlockCodeActivityProgress> => {
  const { data } = await requester().get(
    `/block-activity/${activityId}/block-activity-progress/${progressId}/`,
  );
  return data;
};

export const updateBlockActivityProgress = async (
  { progressId, activityId }: BlockActivityProgressParam,
  progress: Partial<BlockCodeActivityProgress>,
): Promise<BlockCodeActivityProgress> => {
  const { data } = await requester().patch(
    `/block-activity/${activityId}/block-activity-progress/${progressId}/`,
    progress,
  );
  return data;
};
